import styled, { css } from "styled-components"
import { fieldStyles } from "../styles"

const sharedStyles = css`
  ${fieldStyles}
  font: inherit;
  line-height: 22px;

  grid-area: 1 / 1 / 2 / 2;
`

export const TextAreaWrapper = styled.div`
  display: grid;
  overflow-x: auto;

  &:after {
    content: attr(data-replicated-value) " ";
    white-space: pre-wrap;
    visibility: hidden;
    ${sharedStyles}
  }
`

export const TextArea = styled.textarea`
  resize: none;
  overflow: hidden;
  ${sharedStyles}
  height: auto;
  word-wrap: break-word; /* Ensures words wrap inside the textarea */
  overflow-wrap: break-word; /* Handles long strings without spaces */

  ${({ large }) =>
    large &&
    `
    min-height: 20rem;
  `}

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      padding: 16px;
    `}
`
